import React, { useLayoutEffect } from 'react';
import App from './App';
import { useAuth } from './contexts/AuthContext';
import { useInterfaceLoading } from './contexts/GlobalFeatures';
import BunnyLoading from './components/BunnyLoading';
import { getUserPermissions } from './utils/userProfileContextHelpers';
import { useHotelOwner } from './contexts/HotelOwnerContext';
import useUserProfile from './customHooks/useUserProfile';
import { adaptHotelOwnerToState } from './services/hotelOwner/hotelOwnerAdapters';
import { useNotification } from './contexts/NotificationsContext';
import { commonErrorMessage } from './services/api';
import useTranslate from './customHooks/useTranslate';

//  gestiona la autenticación y cargar los primeros datos del usuario / owner antes de renderizar App
const AppGate = () => {
    const { setErrorMessage } = useNotification();
    const translate = useTranslate();
    const { setIsLoadingInterface, isLoadingInterface } = useInterfaceLoading();
    const { checkAuthentication } = useAuth();
    const { getInitialOwnerData, saveOwnerData } = useHotelOwner();
    const {
        getInitialProfileData,
        username,
        updateSettings,
        handleProfileData,
    } = useUserProfile();

    useLayoutEffect(() => {
        setIsLoadingInterface(true);
        checkAuthentication()
            .then(async (authenticated: boolean) => {
                if (authenticated) {
                    const [ownerData, userProfile] = await Promise.all([
                        getInitialOwnerData(),
                        getInitialProfileData(),
                    ]);
                    if (ownerData) {
                        saveOwnerData(adaptHotelOwnerToState(ownerData));
                        const mainUser = {
                            ReadOnly: false,
                            Admin: true,
                            SystemUser: ownerData.SystemUser,
                            MainUser: true,
                        };
                        const users = [...ownerData.Users, mainUser];
                        const permissions = getUserPermissions(username, users);
                        updateSettings({
                            ...permissions,
                        });
                    }
                    if (userProfile) {
                        await handleProfileData(ownerData?.Signed, userProfile);
                    }
                }
            })
            .catch(() => {
                setErrorMessage(translate(commonErrorMessage));
            })
            .finally(() => {
                setIsLoadingInterface(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {isLoadingInterface ? (
                <div className='App'>
                    <BunnyLoading />
                </div>
            ) : (
                <App />
            )}
        </>
    );
};

export default AppGate;
